import React from "react";
import PropTypes from "prop-types";

import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const propTypes = {
  currentPage: PropTypes.number,
};

const SkeletonProducts = ({ currentPage }) => {
  return (
    <SkeletonTheme height={38}>
      <div className="mb-4">
        <Skeleton width="20%" height={25} />
      </div>
      {currentPage < 2 && (
        <>
          <div className="row mb-5">
            <div className="mb-4">
              <Skeleton />
            </div>
            <Skeleton height="300px" />
          </div>
          <div className="grid lg:grid-cols-4 gap-4 mb-5">
            <Skeleton />
            <Skeleton />
            <Skeleton />
            <Skeleton />
          </div>
          <div className="grid lg:grid-cols-2">
            <div className="">
              <Skeleton width="50%" />
            </div>
            <div className="">
              <Skeleton width="70%" />
            </div>
          </div>
        </>
      )}

      <div className="grid lg:grid-cols-4 gap-6 mt-4">
        {[...Array(8)].map((num, i) => (
          <div key={i} id={num} className="mb-4">
            <div className="img">
              <Skeleton className="mb-2" height={200} />
            </div>
            <div className="info">
              <Skeleton className="mb-2" width="50%" height={20} />
              <Skeleton className="mb-2" width="75%" height={20} />
              <Skeleton className="mb-2" width="25%" height={20} />
            </div>
          </div>
        ))}
      </div>
    </SkeletonTheme>
  );
};

SkeletonProducts.propTypes = propTypes;

export default SkeletonProducts;
